import { css, keyframes } from "@emotion/core";
import { vw } from "../cssUtil";
export const icShow = keyframes `
from {
  opacity: 0;
  transform: scale(0.9);
}
to {
  opacity: 1;
  transform: scale(1);
}
`;
export const icContainer = css({
    backgroundColor: `rgba(0, 0, 0, 0.5)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
export const icBox = css({
    backgroundColor: "#fff",
    boxShadow: `1px 1px 1px #4e4e4e`,
    animation: `${icShow} 300ms`,
    padding: vw(20),
    borderRadius: vw(15),
    "> div": {
        marginBottom: vw(15),
        width: vw(200)
    },
    "> div:last-child": {
        marginBottom: 0
    },
    "@media (min-width: 769px)": {
        padding: "15px",
        borderRadius: "5px",
        "> div": {
            marginBottom: "15px",
            width: "200px"
        }
    }
});
export const icImg = css({
    img: {
        width: "100%"
    },
    p: {
        color: "#999",
        textAlign: "right",
        verticalAlign: "middle",
        display: "flex",
        alignItems: "center",
        marginTop: vw(5),
        fontSize: vw(12),
        svg: {
            width: vw(16),
            marginRight: vw(3),
            path: {
                fill: "#999"
            }
        },
        "@media (min-width: 769px)": {
            marginTop: "5px",
            fontSize: "12px",
            svg: {
                width: "15px",
                marginRight: "3px"
            }
        }
    }
});
export const icCode = css({
    input: {
        textAlign: `center`
    }
});
export const icBtn = css({});
